import React, { useState, useContext, useEffect } from "react"
import DashboardTabContent from "./dashboard-tab-content"
import Dashboard from "./dashboard-heading"
import Roadmap from "./roadmap/Roadmap"
import "./dashboard.css"
import { useQueryParam, StringParam } from "use-query-params"
import { PropsContext } from "./PropsContext"
import { FirebaseContext, useAccessControl } from "../Firebase"
import LoadingSpinner from "../loading/LoadingSpinner"
import ProspectiveStudentLandingPage from "./prospective-student-tool/ProspectiveStudentLandingPage"
import { tabsAccessibleToProspectiveStudents } from "./prospective-student-tool/tabsAccessibleToProspectiveStudents"

const DashboardExplore = (props) => {
  const { user, profile, firebase, notifier, prospectivePreviewCode } = useContext(FirebaseContext)

  const [tabParam] = useQueryParam("tab", StringParam)

  // access control hook to ensure user is authenticated and has active membership, otherwise redirect to login page with redirect back to dashboard and tab selected
  const { isLoading, hasAccess } = useAccessControl({
    requireAuth: true,
    requireActiveMembership: true,
    redirectTo: tabParam ? `/login/?redirectTo=/dashboard/?tab=${tabParam}` : "/login/",
  })   
  

  // const [isWelcomeSent, setIsWelcomeSent] = useState(false)

  // useEffect(() => {
  //   const sendAsyncWelcome = async () => {
  //     if (!!profile && !isWelcomeSent) {
  //       await sendWelcomeNotification(profile?.loginCount)
  //     }
  //   }

  //   sendAsyncWelcome()
  // }, [])

  // const sendWelcomeNotification = async (loginCount) => {
  //   if (isWelcomeSent) return
  //   setIsWelcomeSent(true)
  //   const visitCount = await firebase.getVisitCount()

  //   if (visitCount <= 1 && loginCount <= 1) {
  //     await notifier.handleWelcomeNotification()
  //   }

  //   if (visitCount > 1) {
  //     await notifier.handleReturningUserNotification()
  //   }
  // }

  if (isLoading || !profile) {
    return <LoadingSpinner />
  }

  // A prospective student's dashboard is a school-specific page
  const isProspectiveStudent = profile.prospectiveSchoolCode || prospectivePreviewCode
  if (isProspectiveStudent && !tabsAccessibleToProspectiveStudents.has(tabParam)) {
    return <ProspectiveStudentLandingPage />
  }

  // Find the tab content matching the current ?tab= param.
  // When no param is present, show the main dashboard homepage instead.
  const cleanParam = tabParam?.replace(/\/$/, "") ?? ""
  const activeTab = DashboardTabContent.find((tab) => tab.param === cleanParam)
  const activeTabContent = activeTab?.content
  const activeTabContainerClassName = activeTab?.containerClassName

  return (
    <PropsContext.Provider value={{ ...props }}>
      <section>
        {!cleanParam ? (
          <Roadmap />
        ) : (
          <>
            <div id="start" />
            <div className={`dashboard-tab-panel ${activeTabContainerClassName ?? "w-container w-pt-2"}`}>
              {activeTabContent}
            </div>
          </>
        )}
      </section>
    </PropsContext.Provider>
  )
}

export default DashboardExplore
